module.exports = __webpack_public_path__ + "img/nodes.176a1b5.png";